import React from 'react'
import MedicalRecordsUpload from '../Components/MedicalRecords/MedicalRecordsUpload'

const MedicalRecordsUploadView = () => {
  return (
    <div>
        <MedicalRecordsUpload />
    </div>
  )
}

export default MedicalRecordsUploadView